import { Injectable } from '@angular/core'
import { HttpService } from '@surgetech-eu/core'
import { Observable } from 'rxjs'

const url = `/libraries/management/types/unitOfMeasure/entries`

@Injectable()
export class UnitOfMeasureService {
    constructor(private http: HttpService) {}

    getAll(): Observable<any[]> {
        return this.http.get(url)
    }
}
